import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect, withRouter } from 'react-redux'
import { Redirect } from 'react-router-dom';

import {
  REQUEST_SUCCESS,
  REQUEST_ERROR,
  REQUEST_FETCHING,
  REQUEST_UNSTARTED,
} from '../constants/requestStates'

import AppLoadingPageContainer from '../containers/AppLoadingPageContainer'
import DysregulationQuizPageContainer from '../containers/DysregulationQuizPageContainer'
import DysregulationQuizResultPageContainer from '../containers/DysregulationQuizResultPageContainer'

import smoothscroll from 'smoothscroll-polyfill';
import agent from '../agent'

import {
  commonTriggerRequest,
  commonUpdateQuizResultKey,
  resetCommon,
} from '../actions/common';

import {
  REQ_FETCH_DEPLOYMENT_CONFIG,
} from '../constants/requestTypes'

class QuizAppContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      quizResultKey: "",
      quizResultRequest: {},
      quizResultRequestState: REQUEST_UNSTARTED,
    }
  }


  async retrieveQuizResults(quizResultKey) {
    const filename = this.state.quizResultKey || quizResultKey
    console.log(`KEY: ${filename}`)

    this.setState({quizResultKey: filename, quizResultRequestState: REQUEST_FETCHING})
    try {
      const result = await agent.NeuroFitBackend.fetchQuizResult({filename})
      this.setState({quizResultKey: filename, quizResultRequestState: REQUEST_SUCCESS, quizResultRequest: result})
    } catch (err) {
      this.setState({quizResultKey: filename, quizResultRequestState: REQUEST_ERROR})
    }
  }


  async componentDidMount() {
    // Kick off requests to load the app.
    this.props.dispatch(commonTriggerRequest(REQ_FETCH_DEPLOYMENT_CONFIG))

    // Run initial requests here.
    if (this.props.location.pathname.startsWith("/quiz/r/")) {
      const quizResultKey = this.props.match.params.quizResultKey || (new URL(document.location)).searchParams.get("id")
      await this.retrieveQuizResults(quizResultKey)
    }

  }

  componentWillUnmount() {
    this.props.dispatch(resetCommon());
  }

  render() {
    const {quizResultRequest, quizResultRequestState} = this.state
    const pathname = this.props.location.pathname
    const isQuizPage = (pathname === "/quiz")
    const isQuizResultsPage = (pathname.startsWith("/quiz/r/"))
    
    const isQuizResultFetched = (isQuizResultsPage && (quizResultRequestState === REQUEST_SUCCESS))

    return (
      <div>
        {(isQuizPage) ? (
            <DysregulationQuizPageContainer
              props={this.props}
            />
          ) : (
            (isQuizResultsPage) ? (
              (!isQuizResultFetched) ? (
                <AppLoadingPageContainer
                  appLoadResultState={quizResultRequestState}
                  onReloadApp={() => this.retrieveQuizResults()}
                  appLoadErrorMessage={"Error: Unable to load quiz results."}
                  props={this.props}
                />
              ) : (
                <DysregulationQuizResultPageContainer
                  props={this.props}
                  fetchQuizResult={quizResultRequest}
                />
              )
            ) : ( 
              <Redirect to="/quiz" />
            )
          )
        }
      </div>
    );
  }
}

QuizAppContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({...state.common});

export default connect(mapStateToProps)(QuizAppContainer);
